import * as angular from "angular";
import * as _ from "lodash";


export class MapSearchService {
  markers: any[] = [];

  constructor(private $log) {
  }

  setSearchBox(_map, _input) {
    const searchBox = new google.maps.places.SearchBox(_input);

    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();

      this.clearMarkers();

      _.forEach(places, (_place) => {
        const icon = {
          url: _place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25)
        };

        // Create a marker for each place.
        this.markers.push(new google.maps.Marker({
          map: _map,
          icon: icon,
          title: _place.name,
          position: _place.geometry.location
        }));

      });

      _map.doCenter(this.markers);
    });
  }

  private clearMarkers() {
    _.forEach(this.markers, (_marker) => {
      _marker.setMap(null);
    });
    this.markers = [];
  }
}

angular
  .module('bringoz.admin.map')
  .service('mapSearchService', MapSearchService);
